import React from 'react'
import PropTypes from 'prop-types'
import { LazyLoadImage } from 'react-lazy-load-image-component'

// Bare centered-stacked card: image on top, white content panel below with
// centered logo/headline/description and a full-width black "Learn more"
// button — no surrounding app chrome. Used for the 1:1 placement and several
// of the 1.91:1 mobile-card / General skins (Figma nodes 31507:15972,
// 31508:15986, 31510:16122/16137/16168, 31511:16189, 31518:16596 — see
// googleDisplayVariations.js).
const BareStackedCard = ({ ad }) => {
  const { headline, description, media, logo, businessName, callToAction } = ad

  return (
    <div className="google-display-card google-display-card--stacked">
      {/* visibleByDefault: see BareGradientCard.jsx — avoids the lazy-load
          placeholder's raw-pixel inline height inflating a horizontally-
          scrolling row for any card not yet scrolled into view. */}
      <LazyLoadImage
        className="google-display-card__media"
        src={media?.url}
        alt={media?.filename}
        width={media?.width}
        height={media?.height}
        visibleByDefault
      />
      <div className="google-display-card__panel">
        {logo?.url && (
          <img className="google-display-card__logo google-display-card__logo--centered" src={logo.url} alt={businessName} />
        )}
        <div className="google-display-card__headline google-display-card__headline--centered">{headline}</div>
        <div className="google-display-card__description">{description}</div>
      </div>
      <button type="button" className="google-display-card__cta-block">
        {callToAction}
      </button>
    </div>
  )
}

BareStackedCard.propTypes = {
  ad: PropTypes.shape({
    headline: PropTypes.string,
    description: PropTypes.string,
    callToAction: PropTypes.string,
    media: PropTypes.object,
    logo: PropTypes.object,
    businessName: PropTypes.string,
  }).isRequired,
}

export default BareStackedCard
